import axios from '@/apis/axios';

class Nominator 
{
    static async getCorporateData()
    {
        const response = await axios.get(`/api/admin/formation/nominators/corporate-data`);

        return response.data.data;
    }
}

export default Nominator;